import React, { useState, useEffect} from "react";
import Zippy from './Zippy';
import TimePicker from './TimePicker';
import Footer from './Footer';
import { getMarkDown, useDetectMobile } from '../utils';
import '../../../stylesheets/triagebot/AppointmentPicker.scss';

//************************* */

const AppointmentPickerMessage = ({ message, sendMessage, disabled }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [openedZippy, setOpenedZippy] = useState(0);
    const [showAll, setShowAll] = useState(false);
    const [providerName, setProviderName] = useState('');

    const [hasError, setHasError] = useState(
        (message && message.data && message.data.length && message.data[0].errorInScheduling)
            ? message.data[0].errorInScheduling
            : false)

    useEffect(() => {
        const element = document.getElementsByClassName('loader');
        if (element && element?.length > 0) {
            element[0].style.visibility = "hidden"; // Set visibility to hidden
        }
        const schedulingElements = document.querySelectorAll("[id='Scheduling']");
        schedulingElements.forEach((el, index) => {
            if(schedulingElements.length > 1 && index !== (schedulingElements.length - 1)) {
                el.style.display = "none";
            }
        });
    }, [])

    if (!(sendMessage instanceof Function))
        sendMessage = () => { };

    const isDisabled = disabled || submitted;

    const isValid = selectedTime;

    const { isMobile } = useDetectMobile();
    
    const aemMeridiem = {
        All : message?.data?.[1]?.amPmTexts?.allText,
        AM  : message?.data?.[1]?.amPmTexts?.amText,
        PM  : message?.data?.[1]?.amPmTexts?.pmText,
        ViewLess : message?.data?.[1]?.amPmTexts?.viewText,
        LoadMore : message?.data?.[1]?.amPmTexts?.loadText
        
    }

    const header = (message.data && message.data.length)
        ? message.data[0].headerText || message.data[0].header
        : ''

    const subHeader = (message.data && message.data.length)
        ? message.data[0].subHeaderText
        : ''

    const Language = (message.data && message.data.length)
    ? message.language
    : '';

    const errorMessage = (message && message.data && message.data.length && message.data[0].errorMessage)
        ? message.data[0].errorMessage
        : ''
    
    const unavailableTimeSlots = new Set(
        (message?.data?.[0]?.unavailableSlots ?? []).map((slot) => Number(slot))
    );

    const filterUnavailableSlots = (slots = []) => {
        return slots?.filter((slot) => !unavailableTimeSlots?.has(Number(slot)));
    };


    const cancelButton =(message.buttons?.[0].displayText)
        ? message.buttons?.[0].displayText
        : ''
    
    const confirmButton =(message.buttons?.[1].displayText)
        ? message.buttons?.[1].displayText
        : ''

    const appointmentStatusText = (message.data && message.data.length)
    ? message.data[1].appointmentStatusText
    : ''
    
    const todayText = (message.data && message.data.length)
    ? message.data[1].todayText
    : ''

    const monthsText = {
        January : message?.data?.[1]?.monthsText?.January,
        February  : message?.data?.[1]?.amPmTexts?.February,
        March  : message?.data?.[1]?.amPmTexts?.March,
        April  : message?.data?.[1]?.monthsText?.April,
        May  : message?.data?.[1]?.monthsText?.May,
        June  : message?.data?.[1]?.monthsText?.June,
        July  : message?.data?.[1]?.monthsText?.July,
        August  : message?.data?.[1]?.monthsText?.August,
        September  : message?.data?.[1]?.monthsText?.September,
        October  : message?.data?.[1]?.monthsText?.October,
        November  : message?.data?.[1]?.monthsText?.November,
        December  : message?.data?.[1]?.monthsText?.December
    }


    const slotsMilli =  filterUnavailableSlots(message?.data?.[1]?.allSlots?.[0]?.slots);

    const slotsDate = slotsMilli
        .filter((value) => { return (Number.isInteger(value)) })
        .map((millisec) => { return new Date(millisec) })

    const uniqueTitleDates = [...new Set(slotsDate.map((date) => { return getDateString(date) }))]

    const validDates = uniqueTitleDates.map((titleDate) => {
        return {
            displayDate: titleDate,
            times: slotsDate.filter((date) => { return getDateString(date) === titleDate })
        }
    })

    const getFilteredTimes = (times) => {
        switch (selectedFilter) {
            case 'am': return times.filter((times) => { return times.getUTCHours() < 12 });
            case 'pm': return times.filter((times) => { return times.getUTCHours() >= 12 });;
            default: return times;
        }
    };

    const getTitle = (uniqueDate, count) => {
        const today = new Date();
        const dateObj = new Date(uniqueDate);
        const isToday =
            today.getFullYear() === dateObj.getFullYear() &&
            today.getMonth() === dateObj.getMonth() &&
            today.getDate() === dateObj.getDate();
        
        const formattedDate = new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(dateObj);
        
        const parts = formattedDate.split(" de ");
        const spanishDate = `${parts[1]} ${parts[0]} ${parts[2]}`;

        const displayDate = Language=='spanish'?isToday ? `${todayText} - ${spanishDate}` : spanishDate: isToday ? `${todayText} - ${uniqueDate}` : uniqueDate;
        return (
            <span className='title'>
                <span>
                   <b> {displayDate}</b>
                </span>
                <span>
                    {count}
                    {isMobile || appointmentStatusText}
                </span>
            </span>
        )
    }

    const toggleZippies = (zippy) => {
        setOpenedZippy(zippy);
    }

    const setSelectedDateTime = (date, time) => {
        setSelectedDate(date);
        setSelectedTime(time);
        setHasError(false);
    }

    const cancelPress = () => {
        sendMessage('rewind', ['summaryPlaceHolder', 'emergency'], ['summaryPlaceHolder', 'emergency']);
        
        sendMessage('message', 'returnerr', 'returnerr');
    }

    const submitPress = (event, button) => {
        if (submitted) return;

        setSubmitted(true);

        sendMessage('message', selectedTime, selectedTime);
    }

    function getDateString(date) {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        const month = months[date.getUTCMonth()];
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();

        return `${month} ${day}, ${year}`;
    }

    const handleChangeOutline = (value) => {
        setSelectedFilter(value);

        document.activeElement.blur();
    }

    const contactTag = message?.data?.[1]?.contactTag;

    const contactNum = contactTag?.match(/(?:[-]*\d){10,13}/g);
    const contactNumText = (contactNum && contactNum.length > 0 ) ? `tel:+1${contactNum[0]}` : '';
    const subHeaderSplitText = contactTag?.split(contactNum?.[0]);

    const nonPcpText = message?.data?.[1]?.nonPcpText;

    return (
        <div className={(isDisabled ? 'disabled ' : '') + (isMobile ? 'mobile ' : '') + 'desktop apt-picker card'}>
            <div className='content'>
                <div className='header'>
                    <h2 className="headerText">{getMarkDown(header)}</h2>
                    <div className='subheader'>
                        {getMarkDown(subHeader)}
                    </div>
                </div>
                {
                    (errorMessage !== '') &&
                    <div className='alert'>
                        {errorMessage}
                    </div>
                }
                <div className='body'>

                    <div className='filter-bar'>
                        <button
                            className={selectedFilter === 'am' ? 'selected' : ''}
                            onClick={() => handleChangeOutline('am')}
                            disabled={isDisabled}
                        >
                            {aemMeridiem.AM.replace('a.m.', 'AM')} 
                        </button>
                        <button
                            className={selectedFilter === 'pm' ? 'selected' : ''}
                            onClick={() => handleChangeOutline('pm')}
                            disabled={isDisabled}
                        >
                            {aemMeridiem.PM.replace('p.m.', 'PM')} 
                        </button>
                        <button
                            className={selectedFilter === 'all' ? 'selected' : ''}
                            onClick={() => handleChangeOutline('all')}
                            disabled={isDisabled}
                        >
                            {aemMeridiem.All}
                        </button>
                    </div>

                    {
                        validDates.map((date, i) => {
                            const filteredTimes = getFilteredTimes(date.times);
                            return (
                                <Zippy
                                    title={getTitle(date.displayDate, filteredTimes.length)}
                                    open={(openedZippy === i) && filteredTimes.length && !isDisabled}
                                    onClick={() => {toggleZippies(openedZippy === i ? -1 : i); setShowAll(false); }}
                                    disabled={!filteredTimes.length || isDisabled}
                                    key={date + i}
                                >
                                    <TimePicker
                                        displayTimes={filteredTimes}
                                        selectedTime={(selectedDate === date.titleDate) ? selectedTime : null}
                                        setSelectedTime={(time) => setSelectedDateTime(date.titleDate, time)}
                                        meridiem={selectedFilter}
                                        isMobile={isMobile}
                                        showAll={showAll}
                                        setShowAll={setShowAll}
                                        disabled={isDisabled}
                                        aemMeridiem={aemMeridiem}
                                        providerInfo={slotsMilli}
                                        setProviderName={(provider) => setProviderName(provider)}
                                        ProviderName={providerName}
                                        appointmentStatusText={appointmentStatusText}
                                    />
                                </Zippy>
                            )
                        })
                    }

                    {
                        contactTag
                            ?
                            (isMobile && subHeaderSplitText && subHeaderSplitText.length === 2) ?
                                <div style={{ paddingTop: '8px' }}>
                                    {subHeaderSplitText[0]}<a target = "_blank" href={contactNumText} className={'contactTag'}>{contactNum?.[0]}</a>{subHeaderSplitText[1]}
                                </div>
                                :
                                <div style={{ paddingTop: '8px' }}>
                                    {getMarkDown(contactTag)}
                                </div>
                            :
                            <></>
                    }

                    {
                        nonPcpText 
                        ?
                            <div className="nonPcpText">
                                {nonPcpText}
                            </div>
                        :
                        <></>
                    }

                </div>
            </div>
            { submitted ||
                <Footer>
                    <button
                        onClick={cancelPress}
                        className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                        disabled={isDisabled}
                    >
                        {cancelButton}
                </button>
                    <button
                        onClick={submitPress}
                        className='continue-button'
                        disabled={!isValid || isDisabled}
                    >
                        {confirmButton}
                </button>
                </Footer>
            }
        </div>
    );
}

export default AppointmentPickerMessage;